export default __webpack_public_path__ + "static/media/arkk.8dae49fe.svg";